"use client";

import React, { Children, forwardRef } from "react";
import { Icon, IconProps } from "@cmp-src/data-display/Icon/Icon";

interface CreateIconOptions {
  viewBox?: string;
  path?: React.ReactElement | React.ReactElement[];
  d?: string;
  displayName?: string;
  defaultProps?: IconProps;
}

/**
 * Builds an icon component from SVG paths, drawn with `Icon` (decorative, `currentColor`).
 * The icons in `icons/icons` are made with it.
 */
export function createIcon(options: CreateIconOptions) {
  const {
    viewBox = "0 0 24 24",
    d: pathDefinition,
    displayName,
    defaultProps = {}
  } = options;

  const path = Children.toArray(options.path);

  const Comp = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
    <Icon ref={ref} viewBox={viewBox} {...defaultProps} {...props}>
      {path.length ? path : <path fill="currentColor" d={pathDefinition} />}
    </Icon>
  ));

  Comp.displayName = displayName;

  return Comp;
}
